import { Component } from '@angular/core';
import { LoadingController,NavParams } from 'ionic-angular';
import { HttpService } from '../../../../providers/service/httpservice';
import { AppState } from '../../../../app/app.global';
import { StorageService } from '../../../../providers/service/storageservice';
import { NEWS_DETAIL} from '../../../../providers/config/serviceurl';
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: 'news-detail-page',
  templateUrl: 'detail.html'
})
export  class NewsDetail{
  user:any={};
  resourceUrl:any;//资源url；
  news:any;
  public loading:any;
  constructor(public navParm :NavParams,private loadCtrl:LoadingController,public global: AppState,private httpService:HttpService, private sanitizer: DomSanitizer) {
  	//let newsId = navParm.data.id;
    this.user = StorageService.getObj('currentUser');
    this.resourceUrl = StorageService.getObj('resourceUrl');
    this.loading = this.loadCtrl.create({
      content: '加载中...',
    });
    this.loading.present();
    
		this.loading.dismiss();//加载动画结束
    let newsItem = navParm.data;
    let params:any;
    //从新闻咨询点击
    if(newsItem.ID){
      params = {"username":this.user.username,'id':newsItem.ID};
      this.httpService.get2(NEWS_DETAIL,params).then(anyObj =>this.handleNewsDetail(anyObj));
    }else{
      //从幻灯片点击
      //let id = newsItem.fileUrl;
      // let id = newsItem.fileUrl.substring(10,newsItem.fileUrl.length);
     // params = {"username":this.user.username,'id':id};
     this.news={};
     this.news.secUrl = this.sanitizer.bypassSecurityTrustResourceUrl(newsItem.fileUrl);
    }

    
  }
  handleNewsDetail(obj:any){
  	if(obj){
      this.news = obj.content;
      if(this.news.THIRD_LINK != null && this.news.THIRD_LINK != ''){
        this.news.secUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.news.THIRD_LINK);
      }
      console.dir(this.news);
		}
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/news/detail/detail.ts